export const ERROR_TYPES = {
  generic: 'ERROR_GENERIC',
  gvpGeneric: 'ERROR_GVP_GENERIC',
  gvpLoadingData: 'ERROR_GVP_LOADING_DATA',
  heartbeatMultipleDevices: 'ERROR_HEARTBEAT_MULTIPLEDEVICES',
  blackout: 'ERROR_BLACKOUT',
  blackoutSubtext: 'ERROR_BLACKOUT_SUBTEXT',
  blockUserExpired: '418',
  blockUserWrong: '403'
};
